import { jsx as e } from "react/jsx-runtime";
const t = ({ className: o, name: r, style: a = "regular" }) => {
  const i = a === "emoji";
  return /* @__PURE__ */ e(
    "i",
    {
      "aria-hidden": !0,
      className: `${!i && `fa-${a} fa-${r}`} ${o}`,
      children: i && r
    }
  );
};
export {
  t as default
};
